module.exports = __webpack_public_path__ + "img/05_En.9f91bf14.png";